import React, {useEffect, useState} from "react";
import styles from "./Monitor.module.css"
import {getQueueCount} from "../../services/api";

const Monitor = () => {
    const [queueCount, setQueueCount] = useState(null);

    useEffect(()=> {
        fetchMonitor();
    }, [])

    const fetchMonitor = () => {
        getQueueCount().then(r=>setQueueCount(r));
    }

    const divQueueCount = queueCount && <div className={styles['queue']}>
        {Object.entries(queueCount).map(([key,value])=> (
            <div key={key} className={styles['row']}>
                <strong>{key}</strong>: {String(value)}
            </div>
        ))}
    </div>

    return (<div className={styles['container']}>
        {divQueueCount}
        <div>
            <button onClick={fetchMonitor}>reload</button>
        </div>
    </div>)
}

export default Monitor;